const tabCards = document.querySelectorAll('.tabCard__Item');
const tabContent = document.querySelectorAll('.homepage-six-tabs__tabs-panel-item');
const closePanel = document.querySelectorAll('.previous');

if (tabCards !== null && tabCards !== undefined) {

    tabCards.forEach(function(card, index) {
        card.addEventListener('click', function(e) {
            e.preventDefault();

            let cardIndex = Array.from(card.parentNode.children).indexOf(card);

            tabContent.forEach(function (content, index) {
                content.classList.remove('active');
            });

            tabContent[cardIndex].classList.add('active');
        });
    });

    closePanel.forEach(function(panel, index) {
        panel.addEventListener('click', function(e) {

            tabContent.forEach(function (item, index) {
                item.classList.remove('active');
            });

        });
    });
}



